// /Users/aquila/Documents/IdeaProjects/gdnz/workorder/src/store/index.js

import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import saleOrder from "@/store/modules/sale-order";
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        // State：状态，存储应用程序的数据。
        count: 0,
    },
    getters: {

        // Getters：获取 state 中的数据。

        // 虽然可以直接通过 this.$store.state.total 获取状态数据，但是在 getters 中可以有以下优势：
        /*
            事实上，您确实可以直接通过 this.$store.state.applyAfterSales.applyAfterSales.formData 访问状态管理器中的 state。然而，getters 依然具有重要意义，主要有以下几点原因：
            计算属性：getters 类似于 Vue 组件中的计算属性，允许您对 state 进行计算并返回计算结果。这对于基于 state 中数据生成新数据或对数据进行转换非常有用。
            缓存：getters 可以缓存计算结果。只要依赖的 state 没有发生变化，多次访问 getters 时将返回相同的计算结果，而不会重新计算。这有助于提高应用程序性能。
            封装和可维护性：getters 使您能够在获取 state 时封装逻辑。这意味着，如果您需要更改计算逻辑，只需在 getters 中修改，而不必更改组件中的每个访问点。
            代码复用：getters 可以在不同组件中重复使用，减少重复代码。如果多个组件需要访问相同的计算结果，getters 提供了一个集中的计算方法。
            因此，虽然您可以直接访问 state，但在实际开发过程中，使用 getters 可以让您的代码更具有可维护性、可读性和性能优势。在需要对 state 数据进行计算或转换时，使用 getters 是一个很好的选择。
        *  */
    },
    mutations: {
        // Mutations：修改 state 中的数据，必须是同步操作。
    },
    actions: {
        // Actions：处理异步操作，可以调用 mutations。
    },
    modules: {
        // Modules：将 store 分割成多个模块，每个模块拥有自己的 state、getters、mutations 和 actions。
        user, saleOrder
    },
    plugins: [createPersistedState()]
});
